export default "__VITE_ASSET__DQ2Ei$XS__"